import { useQuery } from '@tanstack/react-query'

import { getPurchaseApplicationTemplates } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks/use-axios'

export const useFetchPurchaseApplicationsTemplates = (
  organizationId: string
) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading } = useQuery({
    enabled: !!organizationId,
    queryFn: () =>
      getPurchaseApplicationTemplates(axiosInstance, {
        organizationId,
      }),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_PURCHASE_APPLICATION_TEMPLATES],
  })

  return { data, isError, isLoading }
}
